<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist [ModelName]="'podvrstadokumentastavka'"
                                      [GetName]="'GetByUrl'"
                                      [ModelProperty]="'Sifra,Naziv'"
                                      [GetParameters]="modelData.MainList.GetParameters"
                                      formControlName="PodVrstaDokumentaStavkaID"
                                      [Label]="'IZVOD.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                                      #autofocus
                                      [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                                      (OnItemSelected)='onPodVrstaSelect()'
                                      [Width]="'600px'"
                                      [AutoSelect]="true"
                                      [AllowAddNew]="true"
                                      [Parameters]="parametersForPodvrstaDokumentStavka"
                                      (GetItems)="PodvrstaDokumentaGetItems($event)">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                  <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                    <span class="error-message" *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Datum dokumenta -->
          <div class="col-md-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="Datum"
                                         name="txtDaNal"
                                         [Label]="'IZVOD.DATUM.SINGULAR'"
                                         [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
                                         (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                  <span *ngFor="let validation of errorMessages.Datum">
                    <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Broj dokumenta -->
          <div class="col-md-4 col-12">
            <div class="form-group row">
              <div class="col-md-8 col-8">
                <yt-input [Type]="'text'"
                          [Label]="'IZVOD.BROJDOKUMENTA.SINGULAR'"
                          formControlName="Broj"
                          [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                  <span *ngFor="let validation of errorMessages.Broj">
                    <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="input-group-append">
                  <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Banka -->
        <!-- <div class="row">
          <div class="col-md-12 col-6">
              <div class="form-group row">
                  <div class="col-md-4 col-12">
                      <div class="form-group row">
                          <div class="col-md-12">
                              <yt-dropdown-picklist
                                  [ModelName]="'banka'"
                                  [GetName]="'get'"
                                  [ModelProperty]="'Naziv'"
                                  [OrderBy]="'Naziv'"
                                  [AllowAddNew]="true"
                                  formControlName="BankaID"
                                  [Label]="'IZVOD.BANKA.SINGULAR'"
                                  >
                              </yt-dropdown-picklist>
                              <div class="form-error" *ngIf="submitted && fc.BankaID.invalid">
                                  <span *ngFor="let validation of errorMessages.BankaID">
                                      <span class="error-message" *ngIf="fc.BankaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div> -->
        <!-- Kraj banka -->
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <div class="btn-group float-right">
          <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                  [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable">
            <span class="fa fa-fa fa-save"></span>
            Sačuvaj
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                  [disabled]="saveDisabled">
            <span class="fa fa-fa fa-undo"></span> Odustani
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <yt-izvod-stavka-update-container #baseInlineContainer
                                          [DetailModelData]="modelData.MainList.DetailList[0]"
                                          [ParentPropertyName]="'IzvodID'"
                                          [ParentPropertyValue]="Item.ID"
                                          [Parameters]="TransferParameters">
        </yt-izvod-stavka-update-container>
      </div>
    </div>
  </form>
  </div>
